const QUILL_TOOLBAR = [[{ 'header': [] }], ['bold', 'italic', 'underline', 'link'], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'script': 'sub' }, { 'script': 'super' }],];

export default QUILL_TOOLBAR;